import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core'
import { ActivatedRoute } from '@angular/router'

export type CheckEmailPathType = 'signUp' | 'restorePassword'

@Component({
  selector: 'bmcore-check-email-page',
  templateUrl: './bmcore-check-email-page.component.html',
  styleUrls: ['./bmcore-check-email-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BmcoreCheckEmailPageComponent implements OnInit {
  message: string

  constructor(private activatedRoute: ActivatedRoute) {}

  ngOnInit(): void {
    const path = this.activatedRoute.snapshot.paramMap.get('path') as CheckEmailPathType
    const email = this.activatedRoute.snapshot.paramMap.get('email')
    this.generateData(path, email)
  }

  generateData(path: CheckEmailPathType, email: string) {
    switch (path) {
      case 'signUp':
        this.message = `To confirm your email, follow the link from the email ${email}`
        break

      case 'restorePassword':
        this.message = `We’ve sent an Email with instructions to ${email}`
        break
    }
  }
}
